import { default as SelectionsGallery } from './SelectionsGallery'
export { default as SelectionsGalleryReducer } from './model/slice'
export default SelectionsGallery
